"use strict";
/**
 * This file has been generated
 * DO NOT EDIT, IT MAY BE OVERWRITTEN
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_service_1 = require("../abstract-service");
var InterfaceService = /** @class */ (function (_super) {
    __extends(InterfaceService, _super);
    function InterfaceService(client, apiConfig) {
        var _this = _super.call(this, client, apiConfig) || this;
        _this.resources = {
            'getAppName': {
                path: "/interface/app-name",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getAppPath': {
                path: "/interface/app-path",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getApplicationParameters': {
                path: "/interface/application-parameters",
                methodType: "GET",
                returnTypeConverter: "Bytes"
            },
            'getAuthorizedHostProtocol': {
                path: "/interface/authorized-host-protocol",
                methodType: "GET",
                returnTypeConverter: "Array<HostProtocol>"
            },
            'getAvailableHostProtocols': {
                path: "/interface/available-host-protocols",
                methodType: "GET",
                returnTypeConverter: "Array<HostProtocol>"
            },
            'getBleAddress': {
                path: "/interface/ble/address",
                methodType: "GET",
                returnTypeConverter: "string_macaddress"
            },
            'getCloudClientId': {
                path: "/interface/cloud/client-id",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getCloudConnectionMode': {
                path: "/interface/cloud/connection-mode",
                methodType: "GET",
                returnTypeConverter: "CloudConnectionMode"
            },
            'getCloudGatewayUrl': {
                path: "/interface/cloud-gateway-url",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getCloudLogin': {
                path: "/interface/cloud/login",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getCloudPassword': {
                path: "/interface/cloud/password",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getCloudServiceName': {
                path: "/interface/cloud/service-name",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getConfigFormatFirmwareVersion': {
                path: "/interface/config-format-firmware-version",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getConfigFormatVersion': {
                path: "/interface/config-format-version",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getConfigVersion': {
                path: "/interface/config-version",
                methodType: "GET",
                returnTypeConverter: "TapVersion"
            },
            'getCurrentGroupId': {
                path: "/interface/current-group-id",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getCurrentHostProtocol': {
                path: "/interface/current-host-protocol",
                methodType: "GET",
                returnTypeConverter: "HostProtocol"
            },
            'getCurrentHostProtocolMaxFrameSize': {
                path: "/interface/current-host-protocol-max-frame-size",
                methodType: "GET",
                returnTypeConverter: "integer_uint32"
            },
            'getCurrentProfileId': {
                path: "/interface/current-profile/id",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getFunctions': {
                path: "/interface/functions",
                methodType: "GET",
                returnTypeConverter: "AvailableFunction"
            },
            'getHostInactivityPeriod': {
                path: "/interface/host-inactivity-period",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getLock': {
                path: "/interface/lock",
                methodType: "GET",
                returnTypeConverter: "InterfaceLock"
            },
            'getMqttRelayClientId': {
                path: "/interface/mqtt/relay/client-id",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getMqttRelayLogin': {
                path: "/interface/mqtt/relay/login",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getMqttRelayNetKey': {
                path: "/interface/mqtt/relay/net-key",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getMqttRelayPassword': {
                path: "/interface/mqtt/relay/password",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getMqttRelayPort': {
                path: "/interface/mqtt/relay/port",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getMqttRelayUrl': {
                path: "/interface/mqtt/relay/url",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getNetworkGatewayIp': {
                path: "/interface/network/gateway-ip",
                methodType: "GET",
                returnTypeConverter: "string_ipv4"
            },
            'getNetworkInfraIp': {
                path: "/interface/network/infra-ip",
                methodType: "GET",
                returnTypeConverter: "string_ipv4"
            },
            'getNetworkInfraIpMask': {
                path: "/interface/network/infra-ip-mask",
                methodType: "GET",
                returnTypeConverter: "string_ipv4mask"
            },
            'getNetworkMode': {
                path: "/interface/network-mode",
                methodType: "GET",
                returnTypeConverter: "NetworkMode"
            },
            'getNfcAutologProfileId': {
                path: "/interface/nfc-autolog-profile-id",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getNfcConnectionPriority': {
                path: "/interface/nfc_connection_priority",
                methodType: "GET",
                returnTypeConverter: "NfcConnectionPriority"
            },
            'getNfcPairingMode': {
                path: "/interface/nfc/pairing-mode",
                methodType: "GET",
                returnTypeConverter: "NfcPairingMode"
            },
            'getPowerOptimisationLevel': {
                path: "/interface/power-optimisation-level",
                methodType: "GET",
                returnTypeConverter: "LowPowerOptimisationLevel"
            },
            'getPublicPassword': {
                path: "/interface/public-password",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getRand': {
                path: "/interface/rand",
                methodType: "GET",
                returnTypeConverter: "Bytes"
            },
            'getSpecialFeatureProfile': {
                path: "/interface/special-feature/{featureId}",
                methodType: "GET",
                returnTypeConverter: "integer_uint16"
            },
            'getUniversalLink': {
                path: "/interface/universal-link",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getUploadPeriod': {
                path: "/cloud/upload-period",
                methodType: "GET",
                returnTypeConverter: "integer_uint32"
            },
            'getWepKey': {
                path: "/interface/wep-key",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getWifiHostname': {
                path: "/interface/wifi/hostname",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'getWifiSSID': {
                path: "/interface/wifi/ssid",
                methodType: "GET",
                returnTypeConverter: "string"
            },
            'keepAlive': {
                path: "/interface/keep-alive",
                methodType: "GET",
                returnTypeConverter: "integer_uint32"
            },
            'login': {
                path: "/interface/login",
                methodType: "POST",
                bodyEncoder: "LoginCredential"
            },
            'loginWithHash': {
                path: "/interface/login-with-hash",
                methodType: "POST",
                bodyEncoder: "LoginCredentialHashed"
            },
            'loginWithUID': {
                path: "/interface/login-uid",
                methodType: "POST",
                bodyEncoder: "Bytes"
            },
            'logout': {
                path: "/interface/logout",
                methodType: "POST"
            },
            'multiRequest': {
                path: "/interface/multi-request",
                methodType: "GET",
                returnTypeConverter: "MultiResponse",
                bodyEncoder: "MultiRequest"
            },
            'postNfcConnectionPriority': {
                path: "/interface/nfc_connection_priority",
                methodType: "POST",
                bodyEncoder: "NfcConnectionPriority"
            },
            'putAppName': {
                path: "/interface/app-name",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putAppPath': {
                path: "/interface/app-path",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putApplicationParameters': {
                path: "/interface/application-parameters",
                methodType: "PUT",
                bodyEncoder: "Bytes"
            },
            'putAuthorizedHostProtocol': {
                path: "/interface/authorized-host-protocol",
                methodType: "PUT",
                bodyEncoder: "Array<HostProtocol>"
            },
            'putClientCertificate': {
                path: "/interface/client-certificate",
                methodType: "PUT",
                bodyEncoder: "Bytes"
            },
            'putClientPrivateKey': {
                path: "/interface/client-private-key",
                methodType: "PUT",
                bodyEncoder: "Bytes"
            },
            'putCloudClientId': {
                path: "/interface/cloud/client-id",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putCloudConnectionMode': {
                path: "/interface/cloud/connection-mode",
                methodType: "PUT",
                bodyEncoder: "CloudConnectionMode"
            },
            'putCloudGatewayUrl': {
                path: "/interface/cloud-gateway-url",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putCloudLogin': {
                path: "/interface/cloud/login",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putCloudPassword': {
                path: "/interface/cloud/password",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putCloudServiceName': {
                path: "/interface/cloud/service-name",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putConfigFormatVersion': {
                path: "/interface/config-format-version",
                methodType: "PUT",
                bodyEncoder: "integer_uint16"
            },
            'putConfigVersion': {
                path: "/interface/config-version",
                methodType: "PUT",
                bodyEncoder: "integer_uint32"
            },
            'putCurrentHostProtocol': {
                path: "/interface/current-host-protocol",
                methodType: "PUT",
                bodyEncoder: "HostProtocol"
            },
            'putHostInactivityPeriod': {
                path: "/interface/host-inactivity-period",
                methodType: "PUT",
                bodyEncoder: "integer_uint16"
            },
            'putLock': {
                path: "/interface/lock",
                methodType: "PUT",
                bodyEncoder: "InterfaceLock"
            },
            'putMqttRelayCertificate': {
                path: "/interface/mqtt-relay-certificate",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putMqttRelayClientId': {
                path: "/interface/mqtt/relay/client-id",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putMqttRelayLogin': {
                path: "/interface/mqtt/relay/login",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putMqttRelayNetKey': {
                path: "/interface/mqtt/relay/net-key",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putMqttRelayPassword': {
                path: "/interface/mqtt/relay/password",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putMqttRelayPort': {
                path: "/interface/mqtt/relay/port",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putMqttRelayUrl': {
                path: "/interface/mqtt/relay/url",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putNetworkGatewayIp': {
                path: "/interface/network/gateway-ip",
                methodType: "PUT",
                bodyEncoder: "string_ipv4"
            },
            'putNetworkInfraIp': {
                path: "/interface/network/infra-ip",
                methodType: "PUT",
                bodyEncoder: "string_ipv4"
            },
            'putNetworkInfraIpMask': {
                path: "/interface/network/infra-ip-mask",
                methodType: "PUT",
                bodyEncoder: "string_ipv4mask"
            },
            'putNetworkMode': {
                path: "/interface/network-mode",
                methodType: "PUT",
                bodyEncoder: "NetworkMode"
            },
            'putNfcAutologProfileId': {
                path: "/interface/nfc-autolog-profile-id",
                methodType: "PUT",
                bodyEncoder: "integer_uint16"
            },
            'putNfcConnectionPriority': {
                path: "/interface/nfc_connection_priority",
                methodType: "PUT",
                bodyEncoder: "NfcConnectionPriority"
            },
            'putNfcPairingMode': {
                path: "/interface/nfc/pairing-mode",
                methodType: "PUT",
                bodyEncoder: "NfcPairingMode"
            },
            'putPowerOptimisationLevel': {
                path: "/interface/power-optimisation-level",
                methodType: "PUT",
                bodyEncoder: "LowPowerOptimisationLevel"
            },
            'putSpecialFeatureProfile': {
                path: "/interface/special-feature/{featureId}",
                methodType: "PUT",
                bodyEncoder: "integer_uint16"
            },
            'putUniversalLink': {
                path: "/interface/universal-link",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putUploadPeriod': {
                path: "/cloud/upload-period",
                methodType: "PUT",
                bodyEncoder: "integer_uint32"
            },
            'putWepKey': {
                path: "/interface/wep-key",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'putWifiSSID': {
                path: "/interface/wifi/ssid",
                methodType: "PUT",
                bodyEncoder: "string"
            },
            'reloadConfig': {
                path: "/interface/config-version",
                methodType: "POST"
            },
            'setSpecialFeatureProfile': {
                path: "/interface/special-feature/{featureId}",
                methodType: "POST",
                bodyEncoder: "integer_uint16"
            },
        };
        return _this;
    }
    /**
    * Get application name
    *
    * LWM2M path: /1024//9
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getAppName = function () {
        var callOptions = this.getAppNameCall();
        return this._call(callOptions);
    };
    /**
    * Get application name
    *
    * LWM2M path: /1024//9
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getAppNameCall = function () {
        var callOptions = this.resources.getAppName;
        return callOptions;
    };
    /**
    * Get app path
    * Application Android à lancer ou page HTML à afficher quand l&#39;IoTize est détecté par le téléphone
    * LWM2M path: /1024//11
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getAppPath = function () {
        var callOptions = this.getAppPathCall();
        return this._call(callOptions);
    };
    /**
    * Get app path
    * Application Android à lancer ou page HTML à afficher quand l&#39;IoTize est détecté par le téléphone
    * LWM2M path: /1024//11
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getAppPathCall = function () {
        var callOptions = this.resources.getAppPath;
        return callOptions;
    };
    /**
    * Get application parameters
    * Paramètres d&#39;application : codes, URL secondaire, etc. le TAP les stocke et les restitue sans les interpréter.
    * LWM2M path: /1024//36
    * @tapVersion(">=1.0")
    * @return Uint8Array api call
    */
    InterfaceService.prototype.getApplicationParameters = function () {
        var callOptions = this.getApplicationParametersCall();
        return this._call(callOptions);
    };
    /**
    * Get application parameters
    * Paramètres d&#39;application : codes, URL secondaire, etc. le TAP les stocke et les restitue sans les interpréter.
    * LWM2M path: /1024//36
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getApplicationParametersCall = function () {
        var callOptions = this.resources.getApplicationParameters;
        return callOptions;
    };
    /**
    * Get authorized host protocols
    *
    * LWM2M path: /1024//17
    * @tapVersion(">=1.0")
    * @return Array<HostProtocol> api call
    */
    InterfaceService.prototype.getAuthorizedHostProtocol = function () {
        var callOptions = this.getAuthorizedHostProtocolCall();
        return this._call(callOptions);
    };
    /**
    * Get authorized host protocols
    *
    * LWM2M path: /1024//17
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getAuthorizedHostProtocolCall = function () {
        var callOptions = this.resources.getAuthorizedHostProtocol;
        return callOptions;
    };
    /**
    * Get available host protocols
    *
    * LWM2M path: /1024//21
    * @tapVersion(">=1.0")
    * @return Array<HostProtocol> api call
    */
    InterfaceService.prototype.getAvailableHostProtocols = function () {
        var callOptions = this.getAvailableHostProtocolsCall();
        return this._call(callOptions);
    };
    /**
    * Get available host protocols
    *
    * LWM2M path: /1024//21
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getAvailableHostProtocolsCall = function () {
        var callOptions = this.resources.getAvailableHostProtocols;
        return callOptions;
    };
    /**
    * Get ble address
    *
    * LWM2M path: /1024//22
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getBleAddress = function () {
        var callOptions = this.getBleAddressCall();
        return this._call(callOptions);
    };
    /**
    * Get ble address
    *
    * LWM2M path: /1024//22
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getBleAddressCall = function () {
        var callOptions = this.resources.getBleAddress;
        return callOptions;
    };
    /**
    * Get cloud client id
    *
    * LWM2M path: /1024//27
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getCloudClientId = function () {
        var callOptions = this.getCloudClientIdCall();
        return this._call(callOptions);
    };
    /**
    * Get cloud client id
    *
    * LWM2M path: /1024//27
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCloudClientIdCall = function () {
        var callOptions = this.resources.getCloudClientId;
        return callOptions;
    };
    /**
    * Get cloud connection mode
    *
    * LWM2M path: /1024//26
    * @tapVersion(">=1.0")
    * @return CloudConnectionMode api call
    */
    InterfaceService.prototype.getCloudConnectionMode = function () {
        var callOptions = this.getCloudConnectionModeCall();
        return this._call(callOptions);
    };
    /**
    * Get cloud connection mode
    *
    * LWM2M path: /1024//26
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCloudConnectionModeCall = function () {
        var callOptions = this.resources.getCloudConnectionMode;
        return callOptions;
    };
    /**
    * Get cloud gateway url
    * Adresse serveur Web du broker MQTT servant au Cloud. Pour envoyer le data-log par exemple. (Mais PAS pour le Relay MQTT)
    * LWM2M path: /1024//12
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getCloudGatewayUrl = function () {
        var callOptions = this.getCloudGatewayUrlCall();
        return this._call(callOptions);
    };
    /**
    * Get cloud gateway url
    * Adresse serveur Web du broker MQTT servant au Cloud. Pour envoyer le data-log par exemple. (Mais PAS pour le Relay MQTT)
    * LWM2M path: /1024//12
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCloudGatewayUrlCall = function () {
        var callOptions = this.resources.getCloudGatewayUrl;
        return callOptions;
    };
    /**
    * Get cloud login id
    *
    * LWM2M path: /1024//28
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getCloudLogin = function () {
        var callOptions = this.getCloudLoginCall();
        return this._call(callOptions);
    };
    /**
    * Get cloud login id
    *
    * LWM2M path: /1024//28
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCloudLoginCall = function () {
        var callOptions = this.resources.getCloudLogin;
        return callOptions;
    };
    /**
    * Get cloud password
    *
    * LWM2M path: /1024//29
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getCloudPassword = function () {
        var callOptions = this.getCloudPasswordCall();
        return this._call(callOptions);
    };
    /**
    * Get cloud password
    *
    * LWM2M path: /1024//29
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCloudPasswordCall = function () {
        var callOptions = this.resources.getCloudPassword;
        return callOptions;
    };
    /**
    * Get the cloud service name
    *
    * LWM2M path: /1024//61
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getCloudServiceName = function () {
        var callOptions = this.getCloudServiceNameCall();
        return this._call(callOptions);
    };
    /**
    * Get the cloud service name
    *
    * LWM2M path: /1024//61
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCloudServiceNameCall = function () {
        var callOptions = this.resources.getCloudServiceName;
        return callOptions;
    };
    /**
    * Get config format firmware version
    * Firmware version that wrote the current configuration
    * LWM2M path: /1024//18
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.getConfigFormatFirmwareVersion = function () {
        var callOptions = this.getConfigFormatFirmwareVersionCall();
        return this._call(callOptions);
    };
    /**
    * Get config format firmware version
    * Firmware version that wrote the current configuration
    * LWM2M path: /1024//18
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getConfigFormatFirmwareVersionCall = function () {
        var callOptions = this.resources.getConfigFormatFirmwareVersion;
        return callOptions;
    };
    /**
    * Get config format version
    *
    * LWM2M path: /1024//8
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.getConfigFormatVersion = function () {
        var callOptions = this.getConfigFormatVersionCall();
        return this._call(callOptions);
    };
    /**
    * Get config format version
    *
    * LWM2M path: /1024//8
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getConfigFormatVersionCall = function () {
        var callOptions = this.resources.getConfigFormatVersion;
        return callOptions;
    };
    /**
    * Get config version
    *
    * LWM2M path: /1024//10
    * @tapVersion(">=1.0")
    * @return TapVersion api call
    */
    InterfaceService.prototype.getConfigVersion = function () {
        var callOptions = this.getConfigVersionCall();
        return this._call(callOptions);
    };
    /**
    * Get config version
    *
    * LWM2M path: /1024//10
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getConfigVersionCall = function () {
        var callOptions = this.resources.getConfigVersion;
        return callOptions;
    };
    /**
    * Get current group id
    *
    * LWM2M path: /1024//7
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.getCurrentGroupId = function () {
        var callOptions = this.getCurrentGroupIdCall();
        return this._call(callOptions);
    };
    /**
    * Get current group id
    *
    * LWM2M path: /1024//7
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCurrentGroupIdCall = function () {
        var callOptions = this.resources.getCurrentGroupId;
        return callOptions;
    };
    /**
    * Get current host protocol
    *
    * LWM2M path: /1024//3
    * @tapVersion(">=1.0")
    * @return HostProtocol api call
    */
    InterfaceService.prototype.getCurrentHostProtocol = function () {
        var callOptions = this.getCurrentHostProtocolCall();
        return this._call(callOptions);
    };
    /**
    * Get current host protocol
    *
    * LWM2M path: /1024//3
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCurrentHostProtocolCall = function () {
        var callOptions = this.resources.getCurrentHostProtocol;
        return callOptions;
    };
    /**
    * Get max frame sizes for current host protocol
    *
    * LWM2M path: /1024//88
    * @tapVersion(">=1.86")
    * @return number api call
    */
    InterfaceService.prototype.getCurrentHostProtocolMaxFrameSize = function () {
        var callOptions = this.getCurrentHostProtocolMaxFrameSizeCall();
        return this._call(callOptions);
    };
    /**
    * Get max frame sizes for current host protocol
    *
    * LWM2M path: /1024//88
    * @tapVersion(">=1.86")
    * @return call options
    */
    InterfaceService.prototype.getCurrentHostProtocolMaxFrameSizeCall = function () {
        var callOptions = this.resources.getCurrentHostProtocolMaxFrameSize;
        return callOptions;
    };
    /**
    * Get current profile id
    *
    * LWM2M path: /1024//2
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.getCurrentProfileId = function () {
        var callOptions = this.getCurrentProfileIdCall();
        return this._call(callOptions);
    };
    /**
    * Get current profile id
    *
    * LWM2M path: /1024//2
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getCurrentProfileIdCall = function () {
        var callOptions = this.resources.getCurrentProfileId;
        return callOptions;
    };
    /**
    * Get functions
    * Get functions
    * LWM2M path: /1024//20
    * @tapVersion(">=1.0")
    * @return AvailableFunction api call
    */
    InterfaceService.prototype.getFunctions = function () {
        var callOptions = this.getFunctionsCall();
        return this._call(callOptions);
    };
    /**
    * Get functions
    * Get functions
    * LWM2M path: /1024//20
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getFunctionsCall = function () {
        var callOptions = this.resources.getFunctions;
        return callOptions;
    };
    /**
    * Get host inactivity period
    * Host inactivity period before switch to standby mode or shutdown depending on optimisation level (res /1024//14). Also tells to disconnect Client after timeout when not in Low-power mode
    * LWM2M path: /1024//34
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.getHostInactivityPeriod = function () {
        var callOptions = this.getHostInactivityPeriodCall();
        return this._call(callOptions);
    };
    /**
    * Get host inactivity period
    * Host inactivity period before switch to standby mode or shutdown depending on optimisation level (res /1024//14). Also tells to disconnect Client after timeout when not in Low-power mode
    * LWM2M path: /1024//34
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getHostInactivityPeriodCall = function () {
        var callOptions = this.resources.getHostInactivityPeriod;
        return callOptions;
    };
    /**
    * Get lock infos
    *
    * LWM2M path: /1024//6
    * @tapVersion(">=1.0")
    * @return InterfaceLock api call
    */
    InterfaceService.prototype.getLock = function () {
        var callOptions = this.getLockCall();
        return this._call(callOptions);
    };
    /**
    * Get lock infos
    *
    * LWM2M path: /1024//6
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getLockCall = function () {
        var callOptions = this.resources.getLock;
        return callOptions;
    };
    /**
    * Get mqtt relay client id.. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//52
    * @tapVersion(">=1.86")
    * @return string api call
    */
    InterfaceService.prototype.getMqttRelayClientId = function () {
        var callOptions = this.getMqttRelayClientIdCall();
        return this._call(callOptions);
    };
    /**
    * Get mqtt relay client id.. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//52
    * @tapVersion(">=1.86")
    * @return call options
    */
    InterfaceService.prototype.getMqttRelayClientIdCall = function () {
        var callOptions = this.resources.getMqttRelayClientId;
        return callOptions;
    };
    /**
    * Get mqtt relay login. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//53
    * @deprecated
    * @tapVersion(">=1.86")
    * @return string api call
    */
    InterfaceService.prototype.getMqttRelayLogin = function () {
        var callOptions = this.getMqttRelayLoginCall();
        return this._call(callOptions);
    };
    /**
    * Get mqtt relay login. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//53
    * @deprecated
    * @tapVersion(">=1.86")
    * @return call options
    */
    InterfaceService.prototype.getMqttRelayLoginCall = function () {
        var callOptions = this.resources.getMqttRelayLogin;
        return callOptions;
    };
    /**
    * Get the mqtt net key for the server
    *
    * LWM2M path: /1024//55
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getMqttRelayNetKey = function () {
        var callOptions = this.getMqttRelayNetKeyCall();
        return this._call(callOptions);
    };
    /**
    * Get the mqtt net key for the server
    *
    * LWM2M path: /1024//55
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getMqttRelayNetKeyCall = function () {
        var callOptions = this.resources.getMqttRelayNetKey;
        return callOptions;
    };
    /**
    * Get the mqtt relay password
    * Mot de passe connexion au broker
    * LWM2M path: /1024//54
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getMqttRelayPassword = function () {
        var callOptions = this.getMqttRelayPasswordCall();
        return this._call(callOptions);
    };
    /**
    * Get the mqtt relay password
    * Mot de passe connexion au broker
    * LWM2M path: /1024//54
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getMqttRelayPasswordCall = function () {
        var callOptions = this.resources.getMqttRelayPassword;
        return callOptions;
    };
    /**
    * Get port of the mqtt broker
    *
    * LWM2M path: /1024//51
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getMqttRelayPort = function () {
        var callOptions = this.getMqttRelayPortCall();
        return this._call(callOptions);
    };
    /**
    * Get port of the mqtt broker
    *
    * LWM2M path: /1024//51
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getMqttRelayPortCall = function () {
        var callOptions = this.resources.getMqttRelayPort;
        return callOptions;
    };
    /**
    * Get mqtt relay url
    *
    * LWM2M path: /1024//50
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getMqttRelayUrl = function () {
        var callOptions = this.getMqttRelayUrlCall();
        return this._call(callOptions);
    };
    /**
    * Get mqtt relay url
    *
    * LWM2M path: /1024//50
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getMqttRelayUrlCall = function () {
        var callOptions = this.resources.getMqttRelayUrl;
        return callOptions;
    };
    /**
    * Get iotize gateway ip on the network
    *
    * LWM2M path: /1024//31
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getNetworkGatewayIp = function () {
        var callOptions = this.getNetworkGatewayIpCall();
        return this._call(callOptions);
    };
    /**
    * Get iotize gateway ip on the network
    *
    * LWM2M path: /1024//31
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getNetworkGatewayIpCall = function () {
        var callOptions = this.resources.getNetworkGatewayIp;
        return callOptions;
    };
    /**
    * Get IoTize device ip on the network
    * Adresse statique IP : ex 192.168.1.10. DHCP si adresse &#x3D; 0.0.0.0. Seulement pour les IoTize Wifi.
    * LWM2M path: /1024//30
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getNetworkInfraIp = function () {
        var callOptions = this.getNetworkInfraIpCall();
        return this._call(callOptions);
    };
    /**
    * Get IoTize device ip on the network
    * Adresse statique IP : ex 192.168.1.10. DHCP si adresse &#x3D; 0.0.0.0. Seulement pour les IoTize Wifi.
    * LWM2M path: /1024//30
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getNetworkInfraIpCall = function () {
        var callOptions = this.resources.getNetworkInfraIp;
        return callOptions;
    };
    /**
    * Get infrastructure ip mask
    * For example: 255.255.255.0
    * LWM2M path: /1024//32
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getNetworkInfraIpMask = function () {
        var callOptions = this.getNetworkInfraIpMaskCall();
        return this._call(callOptions);
    };
    /**
    * Get infrastructure ip mask
    * For example: 255.255.255.0
    * LWM2M path: /1024//32
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getNetworkInfraIpMaskCall = function () {
        var callOptions = this.resources.getNetworkInfraIpMask;
        return callOptions;
    };
    /**
    * Get network mode
    *
    * LWM2M path: /1024//15
    * @tapVersion(">=1.0")
    * @return NetworkMode api call
    */
    InterfaceService.prototype.getNetworkMode = function () {
        var callOptions = this.getNetworkModeCall();
        return this._call(callOptions);
    };
    /**
    * Get network mode
    *
    * LWM2M path: /1024//15
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getNetworkModeCall = function () {
        var callOptions = this.resources.getNetworkMode;
        return callOptions;
    };
    /**
    * Get profile id that will be logged in when starting an encrypted session with NFC
    *
    * LWM2M path: /1024//43
    * @tapVersion(">=1.55")
    * @return number api call
    */
    InterfaceService.prototype.getNfcAutologProfileId = function () {
        var callOptions = this.getNfcAutologProfileIdCall();
        return this._call(callOptions);
    };
    /**
    * Get profile id that will be logged in when starting an encrypted session with NFC
    *
    * LWM2M path: /1024//43
    * @tapVersion(">=1.55")
    * @return call options
    */
    InterfaceService.prototype.getNfcAutologProfileIdCall = function () {
        var callOptions = this.resources.getNfcAutologProfileId;
        return callOptions;
    };
    /**
    * Get NFC connection priority over other protocols
    *
    * LWM2M path: /1024//24
    * @tapVersion(">=1.85")
    * @return NfcConnectionPriority api call
    */
    InterfaceService.prototype.getNfcConnectionPriority = function () {
        var callOptions = this.getNfcConnectionPriorityCall();
        return this._call(callOptions);
    };
    /**
    * Get NFC connection priority over other protocols
    *
    * LWM2M path: /1024//24
    * @tapVersion(">=1.85")
    * @return call options
    */
    InterfaceService.prototype.getNfcConnectionPriorityCall = function () {
        var callOptions = this.resources.getNfcConnectionPriority;
        return callOptions;
    };
    /**
    * Check if nfc paring is mandatory
    *
    * LWM2M path: /1024//13
    * @tapVersion(">=1.0")
    * @return NfcPairingMode api call
    */
    InterfaceService.prototype.getNfcPairingMode = function () {
        var callOptions = this.getNfcPairingModeCall();
        return this._call(callOptions);
    };
    /**
    * Check if nfc paring is mandatory
    *
    * LWM2M path: /1024//13
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getNfcPairingModeCall = function () {
        var callOptions = this.resources.getNfcPairingMode;
        return callOptions;
    };
    /**
    * Get power optimization level
    *
    * LWM2M path: /1024//14
    * @tapVersion(">=1.0")
    * @return LowPowerOptimisationLevel api call
    */
    InterfaceService.prototype.getPowerOptimisationLevel = function () {
        var callOptions = this.getPowerOptimisationLevelCall();
        return this._call(callOptions);
    };
    /**
    * Get power optimization level
    *
    * LWM2M path: /1024//14
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getPowerOptimisationLevelCall = function () {
        var callOptions = this.resources.getPowerOptimisationLevel;
        return callOptions;
    };
    /**
    * Get the device open key
    * Password utilisé pour l&#39;enregistrement. Également défaut du MQTT Relay PWD
    * LWM2M path: /1024//60
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getPublicPassword = function () {
        var callOptions = this.getPublicPasswordCall();
        return this._call(callOptions);
    };
    /**
    * Get the device open key
    * Password utilisé pour l&#39;enregistrement. Également défaut du MQTT Relay PWD
    * LWM2M path: /1024//60
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getPublicPasswordCall = function () {
        var callOptions = this.resources.getPublicPassword;
        return callOptions;
    };
    /**
    * Generate a random number (only for firmware version &lt;&#x3D; 1.83)
    *
    * LWM2M path: /1024//49
    * @deprecated
    * @tapVersion(">=1.0")
    * @return Uint8Array api call
    */
    InterfaceService.prototype.getRand = function () {
        var callOptions = this.getRandCall();
        return this._call(callOptions);
    };
    /**
    * Generate a random number (only for firmware version &lt;&#x3D; 1.83)
    *
    * LWM2M path: /1024//49
    * @deprecated
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getRandCall = function () {
        var callOptions = this.resources.getRand;
        return callOptions;
    };
    /**
    * Get bundle id that have the special feature. Si non définit, retourne 0x0
    *
    * LWM2M path: /1024//{featureId}
    * @tapVersion(">=1.23")
    * @param featureId input
    * @return number api call
    */
    InterfaceService.prototype.getSpecialFeatureProfile = function (featureId) {
        var callOptions = this.getSpecialFeatureProfileCall(featureId);
        return this._call(callOptions);
    };
    /**
    * Get bundle id that have the special feature. Si non définit, retourne 0x0
    *
    * LWM2M path: /1024//{featureId}
    * @tapVersion(">=1.23")
    * @param featureId input
    * @return call options
    */
    InterfaceService.prototype.getSpecialFeatureProfileCall = function (featureId) {
        var callOptions = this.resources.getSpecialFeatureProfile;
        callOptions.pathParameters = {
            "featureId": featureId,
        };
        return callOptions;
    };
    /**
    * Get configured universal link value
    * Universal link will be used by iOS system to find which iIS application is associated with this device. For example: http://www.iotize.com
    * LWM2M path: /1024//19
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getUniversalLink = function () {
        var callOptions = this.getUniversalLinkCall();
        return this._call(callOptions);
    };
    /**
    * Get configured universal link value
    * Universal link will be used by iOS system to find which iIS application is associated with this device. For example: http://www.iotize.com
    * LWM2M path: /1024//19
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getUniversalLinkCall = function () {
        var callOptions = this.resources.getUniversalLink;
        return callOptions;
    };
    /**
    * Uploading period for the cloud
    * Minimum period between 2 data log uploads in milliseconds. If set to 0, data log upload is disabled
    * LWM2M path: /1024//33
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.getUploadPeriod = function () {
        var callOptions = this.getUploadPeriodCall();
        return this._call(callOptions);
    };
    /**
    * Uploading period for the cloud
    * Minimum period between 2 data log uploads in milliseconds. If set to 0, data log upload is disabled
    * LWM2M path: /1024//33
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getUploadPeriodCall = function () {
        var callOptions = this.resources.getUploadPeriod;
        return callOptions;
    };
    /**
    * Get network key
    * Clé WAP / WEP pour connection réseau infrastructure &amp; P2P
    * LWM2M path: /1024//16
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getWepKey = function () {
        var callOptions = this.getWepKeyCall();
        return this._call(callOptions);
    };
    /**
    * Get network key
    * Clé WAP / WEP pour connection réseau infrastructure &amp; P2P
    * LWM2M path: /1024//16
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getWepKeyCall = function () {
        var callOptions = this.resources.getWepKey;
        return callOptions;
    };
    /**
    * Get wifi hostname
    *
    * LWM2M path: /1024//35
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getWifiHostname = function () {
        var callOptions = this.getWifiHostnameCall();
        return this._call(callOptions);
    };
    /**
    * Get wifi hostname
    *
    * LWM2M path: /1024//35
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getWifiHostnameCall = function () {
        var callOptions = this.resources.getWifiHostname;
        return callOptions;
    };
    /**
    * Get wifi ssid
    * May be null if not connected to any network
    * LWM2M path: /1024//25
    * @tapVersion(">=1.0")
    * @return string api call
    */
    InterfaceService.prototype.getWifiSSID = function () {
        var callOptions = this.getWifiSSIDCall();
        return this._call(callOptions);
    };
    /**
    * Get wifi ssid
    * May be null if not connected to any network
    * LWM2M path: /1024//25
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.getWifiSSIDCall = function () {
        var callOptions = this.resources.getWifiSSID;
        return callOptions;
    };
    /**
    * Keep alive.
    * Call this method to ensure communication resources are maintain.
    * LWM2M path: /1024//4
    * @tapVersion(">=1.0")
    * @return number api call
    */
    InterfaceService.prototype.keepAlive = function () {
        var callOptions = this.keepAliveCall();
        return this._call(callOptions);
    };
    /**
    * Keep alive.
    * Call this method to ensure communication resources are maintain.
    * LWM2M path: /1024//4
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.keepAliveCall = function () {
        var callOptions = this.resources.keepAlive;
        return callOptions;
    };
    /**
    * Login
    * User login with username and password
    * LWM2M path: /1024//0
    * Body converter id: "LoginCredential"
    * @tapVersion(">=1.0")
    * @param credential input
    * @return void api call
    */
    InterfaceService.prototype.login = function (credential) {
        var callOptions = this.loginCall(credential);
        return this._call(callOptions);
    };
    /**
    * Login
    * User login with username and password
    * LWM2M path: /1024//0
    * Body converter id: "LoginCredential"
    * @tapVersion(">=1.0")
    * @param credential input
    * @return call options
    */
    InterfaceService.prototype.loginCall = function (credential) {
        var callOptions = this.resources.login;
        callOptions.body = credential;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Login
    * User login with username and password hash
    * LWM2M path: /1024//0
    * Body converter id: "LoginCredentialHashed"
    * @tapVersion(">=1.0")
    * @param credential input
    * @return void api call
    */
    InterfaceService.prototype.loginWithHash = function (credential) {
        var callOptions = this.loginWithHashCall(credential);
        return this._call(callOptions);
    };
    /**
    * Login
    * User login with username and password hash
    * LWM2M path: /1024//0
    * Body converter id: "LoginCredentialHashed"
    * @tapVersion(">=1.0")
    * @param credential input
    * @return call options
    */
    InterfaceService.prototype.loginWithHashCall = function (credential) {
        var callOptions = this.resources.loginWithHash;
        callOptions.body = credential;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Admnistration login
    * Log in as an administrator thanks to the UID
    * LWM2M path: /1024//5
    * Body converter id: "Bytes"
    * @tapVersion(">=1.0")
    * @param uid input
    * @return void api call
    */
    InterfaceService.prototype.loginWithUID = function (uid) {
        var callOptions = this.loginWithUIDCall(uid);
        return this._call(callOptions);
    };
    /**
    * Admnistration login
    * Log in as an administrator thanks to the UID
    * LWM2M path: /1024//5
    * Body converter id: "Bytes"
    * @tapVersion(">=1.0")
    * @param uid input
    * @return call options
    */
    InterfaceService.prototype.loginWithUIDCall = function (uid) {
        var callOptions = this.resources.loginWithUID;
        callOptions.body = uid;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Logout
    *
    * LWM2M path: /1024//1
    * @tapVersion(">=1.0")
    * @return void api call
    */
    InterfaceService.prototype.logout = function () {
        var callOptions = this.logoutCall();
        return this._call(callOptions);
    };
    /**
    * Logout
    *
    * LWM2M path: /1024//1
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.logoutCall = function () {
        var callOptions = this.resources.logout;
        return callOptions;
    };
    /**
    * Execute multiple commands sent in one frame, and return all answers in one
    *
    * LWM2M path: /1024//89
    * Body converter id: "MultiRequest"
    * @tapVersion(">=1.13")
    * @param data input
    * @return MultiResponse api call
    */
    InterfaceService.prototype.multiRequest = function (data) {
        var callOptions = this.multiRequestCall(data);
        return this._call(callOptions);
    };
    /**
    * Execute multiple commands sent in one frame, and return all answers in one
    *
    * LWM2M path: /1024//89
    * Body converter id: "MultiRequest"
    * @tapVersion(">=1.13")
    * @param data input
    * @return call options
    */
    InterfaceService.prototype.multiRequestCall = function (data) {
        var callOptions = this.resources.multiRequest;
        callOptions.body = data;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Set NFC connection priority over other protocols
    *
    * LWM2M path: /1024//24
    * Body converter id: "NfcConnectionPriority"
    * @tapVersion(">=1.85")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.postNfcConnectionPriority = function (key) {
        var callOptions = this.postNfcConnectionPriorityCall(key);
        return this._call(callOptions);
    };
    /**
    * Set NFC connection priority over other protocols
    *
    * LWM2M path: /1024//24
    * Body converter id: "NfcConnectionPriority"
    * @tapVersion(">=1.85")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.postNfcConnectionPriorityCall = function (key) {
        var callOptions = this.resources.postNfcConnectionPriority;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Set application name
    *
    * LWM2M path: /1024//9
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param appName input
    * @return void api call
    */
    InterfaceService.prototype.putAppName = function (appName) {
        var callOptions = this.putAppNameCall(appName);
        return this._call(callOptions);
    };
    /**
    * Set application name
    *
    * LWM2M path: /1024//9
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param appName input
    * @return call options
    */
    InterfaceService.prototype.putAppNameCall = function (appName) {
        var callOptions = this.resources.putAppName;
        callOptions.body = appName;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Set app path
    *
    * LWM2M path: /1024//11
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putAppPath = function (value) {
        var callOptions = this.putAppPathCall(value);
        return this._call(callOptions);
    };
    /**
    * Set app path
    *
    * LWM2M path: /1024//11
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putAppPathCall = function (value) {
        var callOptions = this.resources.putAppPath;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write application parameters
    *
    * LWM2M path: /1024//36
    * Body converter id: "Bytes"
    * @tapVersion(">=1.0")
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putApplicationParameters = function (value) {
        var callOptions = this.putApplicationParametersCall(value);
        return this._call(callOptions);
    };
    /**
    * Write application parameters
    *
    * LWM2M path: /1024//36
    * Body converter id: "Bytes"
    * @tapVersion(">=1.0")
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putApplicationParametersCall = function (value) {
        var callOptions = this.resources.putApplicationParameters;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write authorized host protocols
    *
    * LWM2M path: /1024//17
    * Body converter id: "Array&lt;HostProtocol&gt;"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return void api call
    */
    InterfaceService.prototype.putAuthorizedHostProtocol = function (mode) {
        var callOptions = this.putAuthorizedHostProtocolCall(mode);
        return this._call(callOptions);
    };
    /**
    * Write authorized host protocols
    *
    * LWM2M path: /1024//17
    * Body converter id: "Array&lt;HostProtocol&gt;"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return call options
    */
    InterfaceService.prototype.putAuthorizedHostProtocolCall = function (mode) {
        var callOptions = this.resources.putAuthorizedHostProtocol;
        callOptions.body = mode;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Certificate data in PEM format for SSL mutual authentication, default is NULL
    *
    * LWM2M path: /1024//37
    * Body converter id: "Bytes"
    * @tapVersion(">=1.86")
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putClientCertificate = function (value) {
        var callOptions = this.putClientCertificateCall(value);
        return this._call(callOptions);
    };
    /**
    * Certificate data in PEM format for SSL mutual authentication, default is NULL
    *
    * LWM2M path: /1024//37
    * Body converter id: "Bytes"
    * @tapVersion(">=1.86")
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putClientCertificateCall = function (value) {
        var callOptions = this.resources.putClientCertificate;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * private key data in PEM format for SSL mutual authentication, default is NULL
    *
    * LWM2M path: /1024//38
    * Body converter id: "Bytes"
    * @tapVersion(">=1.86")
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putClientPrivateKey = function (value) {
        var callOptions = this.putClientPrivateKeyCall(value);
        return this._call(callOptions);
    };
    /**
    * private key data in PEM format for SSL mutual authentication, default is NULL
    *
    * LWM2M path: /1024//38
    * Body converter id: "Bytes"
    * @tapVersion(">=1.86")
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putClientPrivateKeyCall = function (value) {
        var callOptions = this.resources.putClientPrivateKey;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud client id
    *
    * LWM2M path: /1024//27
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putCloudClientId = function (value) {
        var callOptions = this.putCloudClientIdCall(value);
        return this._call(callOptions);
    };
    /**
    * Write cloud client id
    *
    * LWM2M path: /1024//27
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putCloudClientIdCall = function (value) {
        var callOptions = this.resources.putCloudClientId;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud connection mode
    *
    * LWM2M path: /1024//26
    * Body converter id: "CloudConnectionMode"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putCloudConnectionMode = function (key) {
        var callOptions = this.putCloudConnectionModeCall(key);
        return this._call(callOptions);
    };
    /**
    * Write cloud connection mode
    *
    * LWM2M path: /1024//26
    * Body converter id: "CloudConnectionMode"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putCloudConnectionModeCall = function (key) {
        var callOptions = this.resources.putCloudConnectionMode;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud gateway url
    *
    * LWM2M path: /1024//12
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putCloudGatewayUrl = function (url) {
        var callOptions = this.putCloudGatewayUrlCall(url);
        return this._call(callOptions);
    };
    /**
    * Write cloud gateway url
    *
    * LWM2M path: /1024//12
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putCloudGatewayUrlCall = function (url) {
        var callOptions = this.resources.putCloudGatewayUrl;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud login id
    *
    * LWM2M path: /1024//28
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putCloudLogin = function (key) {
        var callOptions = this.putCloudLoginCall(key);
        return this._call(callOptions);
    };
    /**
    * Write cloud login id
    *
    * LWM2M path: /1024//28
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putCloudLoginCall = function (key) {
        var callOptions = this.resources.putCloudLogin;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud password
    *
    * LWM2M path: /1024//29
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putCloudPassword = function (key) {
        var callOptions = this.putCloudPasswordCall(key);
        return this._call(callOptions);
    };
    /**
    * Write cloud password
    *
    * LWM2M path: /1024//29
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putCloudPasswordCall = function (key) {
        var callOptions = this.resources.putCloudPassword;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud service name
    *
    * LWM2M path: /1024//61
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param name input
    * @return void api call
    */
    InterfaceService.prototype.putCloudServiceName = function (name) {
        var callOptions = this.putCloudServiceNameCall(name);
        return this._call(callOptions);
    };
    /**
    * Write cloud service name
    *
    * LWM2M path: /1024//61
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param name input
    * @return call options
    */
    InterfaceService.prototype.putCloudServiceNameCall = function (name) {
        var callOptions = this.resources.putCloudServiceName;
        callOptions.body = name;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Set config format version
    *
    * LWM2M path: /1024//8
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.0")
    * @param configFormat input
    * @return void api call
    */
    InterfaceService.prototype.putConfigFormatVersion = function (configFormat) {
        var callOptions = this.putConfigFormatVersionCall(configFormat);
        return this._call(callOptions);
    };
    /**
    * Set config format version
    *
    * LWM2M path: /1024//8
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.0")
    * @param configFormat input
    * @return call options
    */
    InterfaceService.prototype.putConfigFormatVersionCall = function (configFormat) {
        var callOptions = this.resources.putConfigFormatVersion;
        callOptions.body = configFormat;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Set config version
    *
    * LWM2M path: /1024//10
    * Body converter id: "integer_uint32"
    * @tapVersion(">=1.0")
    * @param version input
    * @return void api call
    */
    InterfaceService.prototype.putConfigVersion = function (version) {
        var callOptions = this.putConfigVersionCall(version);
        return this._call(callOptions);
    };
    /**
    * Set config version
    *
    * LWM2M path: /1024//10
    * Body converter id: "integer_uint32"
    * @tapVersion(">=1.0")
    * @param version input
    * @return call options
    */
    InterfaceService.prototype.putConfigVersionCall = function (version) {
        var callOptions = this.resources.putConfigVersion;
        callOptions.body = version;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write current host protocol
    *
    * LWM2M path: /1024//3
    * Body converter id: "HostProtocol"
    * @tapVersion(">=1.0")
    * @param hostProtocol input
    * @return void api call
    */
    InterfaceService.prototype.putCurrentHostProtocol = function (hostProtocol) {
        var callOptions = this.putCurrentHostProtocolCall(hostProtocol);
        return this._call(callOptions);
    };
    /**
    * Write current host protocol
    *
    * LWM2M path: /1024//3
    * Body converter id: "HostProtocol"
    * @tapVersion(">=1.0")
    * @param hostProtocol input
    * @return call options
    */
    InterfaceService.prototype.putCurrentHostProtocolCall = function (hostProtocol) {
        var callOptions = this.resources.putCurrentHostProtocol;
        callOptions.body = hostProtocol;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write host inactivity period
    *
    * LWM2M path: /1024//34
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putHostInactivityPeriod = function (key) {
        var callOptions = this.putHostInactivityPeriodCall(key);
        return this._call(callOptions);
    };
    /**
    * Write host inactivity period
    *
    * LWM2M path: /1024//34
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putHostInactivityPeriodCall = function (key) {
        var callOptions = this.resources.putHostInactivityPeriod;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Set lock infos
    *
    * LWM2M path: /1024//6
    * Body converter id: "InterfaceLock"
    * @tapVersion(">=1.0")
    * @param infos input
    * @return void api call
    */
    InterfaceService.prototype.putLock = function (infos) {
        var callOptions = this.putLockCall(infos);
        return this._call(callOptions);
    };
    /**
    * Set lock infos
    *
    * LWM2M path: /1024//6
    * Body converter id: "InterfaceLock"
    * @tapVersion(">=1.0")
    * @param infos input
    * @return call options
    */
    InterfaceService.prototype.putLockCall = function (infos) {
        var callOptions = this.resources.putLock;
        callOptions.body = infos;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Put MQTT relay topics prefix
    *
    * LWM2M path: /1024//58
    * Body converter id: "string"
    * @tapVersion(">=1.86")
    * @param netkey input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayCertificate = function (netkey) {
        var callOptions = this.putMqttRelayCertificateCall(netkey);
        return this._call(callOptions);
    };
    /**
    * Put MQTT relay topics prefix
    *
    * LWM2M path: /1024//58
    * Body converter id: "string"
    * @tapVersion(">=1.86")
    * @param netkey input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayCertificateCall = function (netkey) {
        var callOptions = this.resources.putMqttRelayCertificate;
        callOptions.body = netkey;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write mqtt relay client id. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//52
    * Body converter id: "string"
    * @tapVersion(">=1.86")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayClientId = function (url) {
        var callOptions = this.putMqttRelayClientIdCall(url);
        return this._call(callOptions);
    };
    /**
    * Write mqtt relay client id. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//52
    * Body converter id: "string"
    * @tapVersion(">=1.86")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayClientIdCall = function (url) {
        var callOptions = this.resources.putMqttRelayClientId;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write mqtt relay password id. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//53
    * Body converter id: "string"
    * @tapVersion(">=1.86")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayLogin = function (url) {
        var callOptions = this.putMqttRelayLoginCall(url);
        return this._call(callOptions);
    };
    /**
    * Write mqtt relay password id. For firmware version &lt;&#x3D; 1.86, use serial number (resource /3//2)
    *
    * LWM2M path: /1024//53
    * Body converter id: "string"
    * @tapVersion(">=1.86")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayLoginCall = function (url) {
        var callOptions = this.resources.putMqttRelayLogin;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write mqtt net key
    *
    * LWM2M path: /1024//55
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param netkey input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayNetKey = function (netkey) {
        var callOptions = this.putMqttRelayNetKeyCall(netkey);
        return this._call(callOptions);
    };
    /**
    * Write mqtt net key
    *
    * LWM2M path: /1024//55
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param netkey input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayNetKeyCall = function (netkey) {
        var callOptions = this.resources.putMqttRelayNetKey;
        callOptions.body = netkey;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write mqtt relay password
    *
    * LWM2M path: /1024//54
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayPassword = function (url) {
        var callOptions = this.putMqttRelayPasswordCall(url);
        return this._call(callOptions);
    };
    /**
    * Write mqtt relay password
    *
    * LWM2M path: /1024//54
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayPasswordCall = function (url) {
        var callOptions = this.resources.putMqttRelayPassword;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write service name of the mqtt broker
    *
    * LWM2M path: /1024//51
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayPort = function (url) {
        var callOptions = this.putMqttRelayPortCall(url);
        return this._call(callOptions);
    };
    /**
    * Write service name of the mqtt broker
    *
    * LWM2M path: /1024//51
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayPortCall = function (url) {
        var callOptions = this.resources.putMqttRelayPort;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write mqtt relay url
    *
    * LWM2M path: /1024//50
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putMqttRelayUrl = function (url) {
        var callOptions = this.putMqttRelayUrlCall(url);
        return this._call(callOptions);
    };
    /**
    * Write mqtt relay url
    *
    * LWM2M path: /1024//50
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putMqttRelayUrlCall = function (url) {
        var callOptions = this.resources.putMqttRelayUrl;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write iotize gateway ip
    *
    * LWM2M path: /1024//31
    * Body converter id: "string_ipv4"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putNetworkGatewayIp = function (key) {
        var callOptions = this.putNetworkGatewayIpCall(key);
        return this._call(callOptions);
    };
    /**
    * Write iotize gateway ip
    *
    * LWM2M path: /1024//31
    * Body converter id: "string_ipv4"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putNetworkGatewayIpCall = function (key) {
        var callOptions = this.resources.putNetworkGatewayIp;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write infrastructure ip
    *
    * LWM2M path: /1024//30
    * Body converter id: "string_ipv4"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putNetworkInfraIp = function (key) {
        var callOptions = this.putNetworkInfraIpCall(key);
        return this._call(callOptions);
    };
    /**
    * Write infrastructure ip
    *
    * LWM2M path: /1024//30
    * Body converter id: "string_ipv4"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putNetworkInfraIpCall = function (key) {
        var callOptions = this.resources.putNetworkInfraIp;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write infrastructure ip mask
    *
    * LWM2M path: /1024//32
    * Body converter id: "string_ipv4mask"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putNetworkInfraIpMask = function (key) {
        var callOptions = this.putNetworkInfraIpMaskCall(key);
        return this._call(callOptions);
    };
    /**
    * Write infrastructure ip mask
    *
    * LWM2M path: /1024//32
    * Body converter id: "string_ipv4mask"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putNetworkInfraIpMaskCall = function (key) {
        var callOptions = this.resources.putNetworkInfraIpMask;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write network mode
    *
    * LWM2M path: /1024//15
    * Body converter id: "NetworkMode"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return void api call
    */
    InterfaceService.prototype.putNetworkMode = function (mode) {
        var callOptions = this.putNetworkModeCall(mode);
        return this._call(callOptions);
    };
    /**
    * Write network mode
    *
    * LWM2M path: /1024//15
    * Body converter id: "NetworkMode"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return call options
    */
    InterfaceService.prototype.putNetworkModeCall = function (mode) {
        var callOptions = this.resources.putNetworkMode;
        callOptions.body = mode;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write profile id
    *
    * LWM2M path: /1024//43
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.55")
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putNfcAutologProfileId = function (value) {
        var callOptions = this.putNfcAutologProfileIdCall(value);
        return this._call(callOptions);
    };
    /**
    * Write profile id
    *
    * LWM2M path: /1024//43
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.55")
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putNfcAutologProfileIdCall = function (value) {
        var callOptions = this.resources.putNfcAutologProfileId;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write in configuration NFC connection priority over other protocols
    *
    * LWM2M path: /1024//24
    * Body converter id: "NfcConnectionPriority"
    * @tapVersion(">=1.85")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putNfcConnectionPriority = function (key) {
        var callOptions = this.putNfcConnectionPriorityCall(key);
        return this._call(callOptions);
    };
    /**
    * Write in configuration NFC connection priority over other protocols
    *
    * LWM2M path: /1024//24
    * Body converter id: "NfcConnectionPriority"
    * @tapVersion(">=1.85")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putNfcConnectionPriorityCall = function (key) {
        var callOptions = this.resources.putNfcConnectionPriority;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Change wether if nfc pairing is mandatory
    *
    * LWM2M path: /1024//13
    * Body converter id: "NfcPairingMode"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return void api call
    */
    InterfaceService.prototype.putNfcPairingMode = function (mode) {
        var callOptions = this.putNfcPairingModeCall(mode);
        return this._call(callOptions);
    };
    /**
    * Change wether if nfc pairing is mandatory
    *
    * LWM2M path: /1024//13
    * Body converter id: "NfcPairingMode"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return call options
    */
    InterfaceService.prototype.putNfcPairingModeCall = function (mode) {
        var callOptions = this.resources.putNfcPairingMode;
        callOptions.body = mode;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write power optimization level
    *
    * LWM2M path: /1024//14
    * Body converter id: "LowPowerOptimisationLevel"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return void api call
    */
    InterfaceService.prototype.putPowerOptimisationLevel = function (mode) {
        var callOptions = this.putPowerOptimisationLevelCall(mode);
        return this._call(callOptions);
    };
    /**
    * Write power optimization level
    *
    * LWM2M path: /1024//14
    * Body converter id: "LowPowerOptimisationLevel"
    * @tapVersion(">=1.0")
    * @param mode input
    * @return call options
    */
    InterfaceService.prototype.putPowerOptimisationLevelCall = function (mode) {
        var callOptions = this.resources.putPowerOptimisationLevel;
        callOptions.body = mode;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write bundle id that own the special feature
    *
    * LWM2M path: /1024//{featureId}
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.23")
    * @param featureId input
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.putSpecialFeatureProfile = function (featureId, value) {
        var callOptions = this.putSpecialFeatureProfileCall(featureId, value);
        return this._call(callOptions);
    };
    /**
    * Write bundle id that own the special feature
    *
    * LWM2M path: /1024//{featureId}
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.23")
    * @param featureId input
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.putSpecialFeatureProfileCall = function (featureId, value) {
        var callOptions = this.resources.putSpecialFeatureProfile;
        callOptions.body = value;
        callOptions.pathParameters = {
            "featureId": featureId,
        };
        return callOptions;
    };
    /**
    * Write universal link value
    *
    * LWM2M path: /1024//19
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return void api call
    */
    InterfaceService.prototype.putUniversalLink = function (url) {
        var callOptions = this.putUniversalLinkCall(url);
        return this._call(callOptions);
    };
    /**
    * Write universal link value
    *
    * LWM2M path: /1024//19
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param url input
    * @return call options
    */
    InterfaceService.prototype.putUniversalLinkCall = function (url) {
        var callOptions = this.resources.putUniversalLink;
        callOptions.body = url;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write cloud mqtt period
    *
    * LWM2M path: /1024//33
    * Body converter id: "integer_uint32"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putUploadPeriod = function (key) {
        var callOptions = this.putUploadPeriodCall(key);
        return this._call(callOptions);
    };
    /**
    * Write cloud mqtt period
    *
    * LWM2M path: /1024//33
    * Body converter id: "integer_uint32"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putUploadPeriodCall = function (key) {
        var callOptions = this.resources.putUploadPeriod;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write network key
    *
    * LWM2M path: /1024//16
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putWepKey = function (key) {
        var callOptions = this.putWepKeyCall(key);
        return this._call(callOptions);
    };
    /**
    * Write network key
    *
    * LWM2M path: /1024//16
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putWepKeyCall = function (key) {
        var callOptions = this.resources.putWepKey;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write wifi ssid
    *
    * LWM2M path: /1024//25
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return void api call
    */
    InterfaceService.prototype.putWifiSSID = function (key) {
        var callOptions = this.putWifiSSIDCall(key);
        return this._call(callOptions);
    };
    /**
    * Write wifi ssid
    *
    * LWM2M path: /1024//25
    * Body converter id: "string"
    * @tapVersion(">=1.0")
    * @param key input
    * @return call options
    */
    InterfaceService.prototype.putWifiSSIDCall = function (key) {
        var callOptions = this.resources.putWifiSSID;
        callOptions.body = key;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Apply the new configuration on the device
    *
    * LWM2M path: /1024//10
    * @tapVersion(">=1.0")
    * @return void api call
    */
    InterfaceService.prototype.reloadConfig = function () {
        var callOptions = this.reloadConfigCall();
        return this._call(callOptions);
    };
    /**
    * Apply the new configuration on the device
    *
    * LWM2M path: /1024//10
    * @tapVersion(">=1.0")
    * @return call options
    */
    InterfaceService.prototype.reloadConfigCall = function () {
        var callOptions = this.resources.reloadConfig;
        return callOptions;
    };
    /**
    * Set bundle id that own the special feature
    *
    * LWM2M path: /1024//{featureId}
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.23")
    * @param featureId input
    * @param value input
    * @return void api call
    */
    InterfaceService.prototype.setSpecialFeatureProfile = function (featureId, value) {
        var callOptions = this.setSpecialFeatureProfileCall(featureId, value);
        return this._call(callOptions);
    };
    /**
    * Set bundle id that own the special feature
    *
    * LWM2M path: /1024//{featureId}
    * Body converter id: "integer_uint16"
    * @tapVersion(">=1.23")
    * @param featureId input
    * @param value input
    * @return call options
    */
    InterfaceService.prototype.setSpecialFeatureProfileCall = function (featureId, value) {
        var callOptions = this.resources.setSpecialFeatureProfile;
        callOptions.body = value;
        callOptions.pathParameters = {
            "featureId": featureId,
        };
        return callOptions;
    };
    return InterfaceService;
}(abstract_service_1.AbstractService));
exports.InterfaceService = InterfaceService;
